export const LifeSafer = "lifesafer";
export const Monitech = "monitechnc";
export const Guardian = "guardianinterlock";
export const QuickStart = "quickstartaz";
